import { select, call } from 'redux-saga/effects';
import apiRoutes from '../utils/apiRoutes';
import { makeRequest } from './makeRequest';

/**
 * Make A15 call to get a country's currency information
 * @param {String} countryCode   the desired country code
 * @return {String} the default currency to use for the country
 */
export function* getDefaultCurrencyForCountry(countryCode) {
    const state = yield select();
    const route = apiRoutes.getCountryConfiguration(state, countryCode);

    const countryConfiguration = yield call(makeRequest, route);

    const defaultSiteId = _.get(countryConfiguration, 'defaultSiteId');

    if (defaultSiteId) {
        const brand = _.head(_.split(defaultSiteId, '-'));

        if (_.includes(['an', 'uo'], brand)) {
            const userCountry = _.get(state, 'core.userLocation.country_code');
            const sitesFromSiteConfig = _.get(state, 'core.siteConfig.sites', []);
            const siteWithDestinationSiteId = _.find(sitesFromSiteConfig, (site) => site.siteId === defaultSiteId);

            if (siteWithDestinationSiteId) {
                if (_.get(siteWithDestinationSiteId, 'defaultCountry.countryCode') === userCountry) {
                    return _.get(siteWithDestinationSiteId, 'defaultCountry.defaultTransactionalCurrency');
                }

                return _.get(siteWithDestinationSiteId, 'defaultCurrency');
            }
        }
    }

    const defaultConvenienceCurrency = _.get(countryConfiguration, 'defaultConvenienceCurrency');
    const defaultTransactionalCurrency = _.get(countryConfiguration, 'defaultTransactionalCurrency');

    return defaultConvenienceCurrency || defaultTransactionalCurrency;
}
